import React from 'react'
import './Bank.css'
import securityImg from '../../images/s-bank-image.png'
export default function Bank() {
  return (
    <div id='s-bank-section'>
        <img src={securityImg} alt="" />      
    </div>
  )
}
